import React from 'react';
import { NamedLink } from '../../components';
import sevaSethuLogo from '../../assets/seva-sethu/seva-sethu-logo.png';
import nitaiGauranga from '../../assets/seva-sethu/nitai-gauranga.png';
import radhaKrishna from '../../assets/seva-sethu/radha-krishna.png';
import ramaSita from '../../assets/seva-sethu/rama-sita.png';

import css from './SevaSethuHero.module.css';

const SevaSethuHero = () => {
  return (
    <section className={css.root}>
      <div className={css.mantraContainer}>
        <div className={css.mantra}>Hare Krishna Hare Krishna Krishna Krishna Hare Hare</div>
        <div className={css.mantra}>Hare Rama Hare Rama Rama Rama Hare Hare</div>
      </div>

      <div className={css.deityImages}>
        <div className={css.deityWrapper}>
          <div className={css.deityContainer}>
            <img src={nitaiGauranga} alt="Sri Sri Nitai Gauranga" className={css.deityImage} />
          </div>
          <div className={css.deityName}>Sri Sri Nitai Gauranga</div>
        </div>

        <div className={css.deityWrapper}>
          <div className={css.deityContainer}>
            <img src={radhaKrishna} alt="Sri Sri Radha Krishna" className={css.deityImage} />
          </div>
          <div className={css.deityName}>Sri Sri Radha Krishna</div>
        </div>

        <div className={css.deityWrapper}>
          <div className={css.deityContainer}>
            <img src={ramaSita} alt="Sri Sri Sita Rama" className={css.deityImage} />
          </div>
          <div className={css.deityName}>Sri Sri Sita Rama</div>
        </div>
      </div>

      <img src={sevaSethuLogo} alt="Seva Sethu" className={css.logo} />
      <div className={css.welcome}>Welcome to Seva Marketplace</div>
      <div className={css.tagline}>"Simple Living, High Thinking" - Srila Prabhupada</div>
      <div className={css.subtitle}>Sacred products and services from our temple community</div>

      <div className={css.heroButtons}>
        <NamedLink name="SearchPage" className={css.btnPrimary}>
          Browse Products
        </NamedLink>
        <NamedLink name="AllSellersPage" className={css.btnSecondary}>
          View All Sellers
        </NamedLink>
      </div>
    </section>
  );
};

export default SevaSethuHero;
